// ----------------------------------------------------------------------
// Diagnósticos recientes del médico (MRU en localStorage).
//
// El médico repite el mismo puñado de códigos todos los días: al enfocar el
// campo vacío se le ofrecen sus últimos 8. Es una comodidad, nunca un dato
// crítico, así que ninguna función de este módulo lanza: si el almacenamiento
// no está disponible o el JSON está corrupto, se comporta como si no hubiera
// historial.
// ----------------------------------------------------------------------

const CLAVE = 'medicore.icd.recientes';

const MAXIMO = 8;

const esDiagnosticoValido = (valor) =>
  Boolean(valor) && typeof valor === 'object' && typeof valor.codigo === 'string' && valor.codigo;

/**
 * Los diagnósticos usados últimamente, el más reciente primero.
 * @returns {Array<object>} Diagnostico[] (máx. 8); [] si no hay o no se pudo leer
 */
export function obtenerRecientes() {
  try {
    const crudo = localStorage.getItem(CLAVE);
    if (!crudo) return [];

    const guardado = JSON.parse(crudo);
    if (!Array.isArray(guardado)) return [];

    return guardado.filter(esDiagnosticoValido).slice(0, MAXIMO);
  } catch {
    return [];
  }
}

/**
 * Coloca un diagnóstico al frente de la lista, deduplicando por código.
 * @param {object} diagnostico Diagnostico completo
 */
export function registrarReciente(diagnostico) {
  if (!esDiagnosticoValido(diagnostico)) return;

  try {
    const previos = obtenerRecientes().filter((item) => item.codigo !== diagnostico.codigo);
    const lista = [diagnostico, ...previos].slice(0, MAXIMO);
    localStorage.setItem(CLAVE, JSON.stringify(lista));
  } catch {
    // localStorage lleno, bloqueado o en modo privado: el historial es
    // prescindible y el buscador sigue funcionando sin él.
  }
}
